import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CSSProperties } from 'react';

import { Colors } from '../../../../utils/Colors';

export const StyledPaper = styled(Paper)`
    background-color: ${Colors.black2};
    border-radius: 8px;
    padding: 24px;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    box-shadow: none;
`;

export const Title = styled(Typography)`
    color: ${Colors.white90};
    font: 600 14px Inter;
    margin-bottom: 16px;
`;

export const StatusContainer = styled(Box)`
    display: flex;
    align-items: flex-start;
    gap: 16px;
    color: ${Colors.white70};
    flex: 1;
`;

export const LoadingContainer = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    flex: 1;
`;

export const LoadingText = styled(Typography)`
    color: ${Colors.white70};
    font-size: 14px;
    font-weight: 500;
`;

export const StatusText = styled(Typography)`
    color: ${Colors.white70};
    font-size: 14px;
    font-weight: 500;
`;

export const ErrorContentContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
`;

export const WorkflowFeedback = styled(Box)`
    background-color: ${Colors.white07};
    border-radius: 4px;
    padding: 12px;
    margin-top: 8px;
    color: ${Colors.white70};
    max-height: 120px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const WorkflowFeedbackText = styled(Typography)`
    font-size: 13px;
    line-height: 1.5;
    color: ${Colors.white70};
    white-space: pre-wrap;
`;

export const successIconStyles: CSSProperties = {
    fill: Colors.lightGreen
};

export const errorIconStyles: CSSProperties = {
    fill: Colors.errorRed2
};
